import { Component } from 'react'
import { connect } from 'react-redux'
import WPAPI from 'wpapi'
import PropTypes from 'prop-types'
import { updateContent } from 'store/content'
import { rootPath } from 'lib/Utils'
import { toggleBlockUI } from 'store/blockUI'

class Careers extends Component {
  componentDidMount () {
    this.props.toggleBlockUI(true)
    const wp = new WPAPI({
      endpoint: `${rootPath}/wp-json`
    })

    // wp.jobPositions = wp.registerRoute('wp/v2', 'job_position')
    wp.offices = wp.registerRoute('wp/v2', 'office')

    let contentObject = { type: 'careers', 'title': 'Careers' }

    wp.offices().get()
      .then((data) => {
        this.props.toggleBlockUI(false)
        contentObject.offices = data
        this.props.updateContent(contentObject)
      })
      .catch((error) => {
        console.warn(error)
        this.props.toggleBlockUI(false)
      })
  }

  render () {
    return null
  }
}

const mapDispatchToProps = {
  updateContent: (content) => updateContent(content),
  toggleBlockUI: (block) => toggleBlockUI(block)
}

Careers.propTypes = {
  updateContent: PropTypes.func,
  toggleBlockUI: PropTypes.func
}

export default connect(null, mapDispatchToProps)(Careers)



// WEBPACK FOOTER //
// ./src/routes/Careers/index.js